import { render, staticRenderFns } from "./TransactionReport.vue?vue&type=template&id=188512f1"
import script from "../../controllers/report/transaction-report.js?vue&type=script&lang=js&external"
export * from "../../controllers/report/transaction-report.js?vue&type=script&lang=js&external"
import style0 from "./TransactionReport.vue?vue&type=style&index=0&id=188512f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports